// Chart palette + dark tooltip, sourced from the app's central color system
// (src/utils/theme/colors.js) so there is ONE source of truth. Recharts needs
// real color strings in JS (it can't read CSS variables), so we map the app's
// tokens to named constants here. Each has a literal fallback so a renamed/
// missing token can never blank the dashboard.
import Colors from "../../../utils/theme/colors";

const pick = (value, fallback) => value || fallback;

export const COPPER = pick(Colors?.app?.primary, "#B87333");           // brand copper
export const TEAL = pick(Colors?.chips?.["Short Clip"], "#33AFB8");
export const GREEN = pick(Colors?.status?.Approved, "#33B86F");
export const MAGENTA = pick(Colors?.chips?.Series, "#B833B8");
export const ACCENTS = [COPPER, TEAL, GREEN, MAGENTA];

// Alert-level colors, from the app's feedback palette.
export const ALERT_ERROR = pick(Colors?.feedback?.error, "#FF3B30");
export const ALERT_WARN = pick(Colors?.feedback?.warning, "#FF9500");
export const ALERT_INFO = TEAL;

const TEXT = pick(Colors?.text?.secondary, "#FFFFFF");

export const AXIS_TICK = { fill: "rgba(255,255,255,0.6)", fontSize: 11 };
export const GRID_STROKE = "rgba(255,255,255,0.08)";

export const TOOLTIP_STYLE = {
  contentStyle: {
    background: "rgba(20,20,20,0.96)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: 8,
    color: TEXT,
    fontSize: 12,
  },
  labelStyle: { color: "rgba(255,255,255,0.7)" },
  itemStyle: { color: TEXT },
};
